import { DataView } from 'primereact/dataview';
import { useEffect, useState } from 'react';
import PageWrapper from '../../../../components/Display/PageWrapper';
import { useAccountContext } from '../../../../contexts/AccountContext';
import { useNavigationContext } from '../../../../contexts/NavigationContext';
import { privateFetch } from '../../../../utils/apiHelper';
import MultipleImagePanel from '../../common/image/MultipleImagePanel';
import ProjectDetail from '../Project/ProjectDetail';
import ProjectItem from '../Project/ProjectItem';
import ProjectPanel from './ProjectPanel';
import styles from "../../../../components/Display/Wrapper.module.scss";

function ProjectPage({ isActive }) {
  const { setActiveView, navigationContext } = useNavigationContext();
  const { accountContext } = useAccountContext();
  const [projectList, setProjectList] = useState([]);
  const [projectDetail, setProjectDetail] = useState(undefined);
  const [panelIsOpen, setPanelIsOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [imagesManagerIsOpen, setImagesManagerIsOpen] = useState(false);
  const [layout, setLayout] = useState('grid');

  const fetchProjectList = async () => {
    await privateFetch('GET', 'dejademain', `/cu/${accountContext.id}/project/`).then((res) => {
      setProjectList(res);
    });
  };

  useEffect(() => {
    fetchProjectList();
  }, []);

  useEffect(() => {
    if (navigationContext.activeProjectId) {
      fetchProjectDetail();
    } else setProjectDetail(undefined);
  }, [navigationContext]);

  const fetchProjectDetail = async () => {
    await privateFetch(
      'GET',
      'dejademain',
      `/cu/${accountContext.id}/project/${navigationContext.activeProjectId}/`
    ).then((res) => {
      if (res) setProjectDetail(res);
    });
  };

  const handleClickProject = (project) => {
    setActiveView("ddproject", project, "activeProjectId");
  };

  const handleOpenManager = () => {
    setPanelIsOpen(true);
  };

  const createProject = async (projectForm) => {
    setLoading(true);
    await privateFetch(
      'POST',
      'dejademain',
      `/cu/${accountContext.id}/project/`,
      'Le projet a bien été ajouté',
      JSON.stringify(projectForm)
    ).then(() => {
      fetchProjectList();
      setPanelIsOpen(false);
      setLoading(false);
    });
  };

  const updateProject = async (projectForm) => {
    setLoading(true);
    await privateFetch(
      'PUT',
      'dejademain',
      `/cu/${accountContext.id}/project/${projectDetail.id}/`,
      'Le projet a bien été modifié',
      JSON.stringify(projectForm)
    ).then(() => {
      fetchProjectList();
      setPanelIsOpen(false);
      fetchProjectDetail(projectDetail.id);
      setLoading(false);
    });
  };

  const handleDeleteProject = async (project) => {
    await privateFetch(
      'DELETE',
      'dejademain',
      `/cu/${accountContext.id}/project/${project.id}/`,
      'Le projet a bien été supprimé'
    ).then(() => {
      fetchProjectList();
      setProjectDetail(undefined);
    });
  };

  const toggleLayout = () => {
    setLayout(layout === 'grid' ? 'list' : 'grid');
  };

  const changeLayoutAction = {
    onClick: toggleLayout,
    ariaLabel: "changer le mode d'affichage",
    icon: layout == "grid" ? "pi-list" : 'pi-th-large'
  };


  const newProjectAction = {
    onClick: handleOpenManager,
    label: 'Ajouter un projet',
    icon: 'pi-plus'
  };

  const goBackProjectAction = {
    onClick: handleClickProject,
    label: 'Retour à la liste'
  };

  const updateProjectImages = async (images) => {
    await privateFetch(
      'PUT',
      'dejademain',
      `/cu/${accountContext.id}/project/${projectDetail.id}/images/`,
      'Les images du projet ont bien été modifiées',
      JSON.stringify({
        images: images.map((image) => image.id)
      })
    ).then(() => {
      fetchProjectDetail();
      // setImagesManagerIsOpen(false);
      setLoading(false);
    });
  };


  return (
    <div className={`h-full w-full flex-col ${isActive ? 'flex' : 'hidden'}`}>
      <PageWrapper
        label="Projets"
        labelAction={handleClickProject}
        actions={projectDetail ? [goBackProjectAction] : [changeLayoutAction, newProjectAction]}
        detail={projectDetail}>
        {!projectDetail ? (
          <div className={styles.pageContentContainer}>
            <div className={` ${layout === 'grid' ? styles.gridLayout : styles.listLayout}`}>
              {projectList.map((project, index) => (
                <ProjectItem key={index} project={project} handleClickProject={() => handleClickProject(project)} layout={layout} />
              ))}
            </div>
          </div>) : (
          <ProjectDetail
            project={projectDetail}
            handleUpdateProject={handleOpenManager}
            handleUpdateImages={() => setImagesManagerIsOpen(true)}
            handleDelete={handleDeleteProject}
          />
        )}

        <ProjectPanel
          isOpen={panelIsOpen}
          onClose={setPanelIsOpen}
          project={projectDetail}
          onCreate={createProject}
          onUpdate={updateProject}
          loading={loading}
        />

        <MultipleImagePanel
          loading={loading}
          isOpen={imagesManagerIsOpen}
          onClose={() => {
            setImagesManagerIsOpen(false);
          }}
          images={projectDetail?.images}
          onValidate={updateProjectImages}
        />
      </PageWrapper>
    </div>
  );
}

export default ProjectPage;
